import useAuthStore from "../stores/useAuthStore";

/**
 * BUG-2232: the user who is *actually logged in right now* — used for stamping
 * created_by / opened_by on records the current cashier is producing (sale
 * orders, discarded carts, till open/close records).
 *
 * Why this is not just `tillData.tillAccess.csUserId`:
 *   `tillData.tillAccess.csUserId` is the user the till was last *registered /
 *   synced* for. It is only refreshed when `syncTillData(<user>)` runs, which
 *   does NOT happen on every login path — a second cashier logging in on an
 *   already-registered shared till (db.tillRegistrations non-empty) can reach
 *   /pos still carrying the previous cashier's cached tillData. `userData` /
 *   `username`, by contrast, get an explicit identity-mismatch re-fetch guard in
 *   Login, Till and Authentication, so they always reflect the live session.
 *   Result on a shared till: BO "opened by" and the receipt "Cashier" code
 *   (server-rendered from s_order.created_by) show the wrong cashier.
 *
 * Resolution order:
 *   1. live authenticated user  (userData.user_id) — the acting cashier
 *   2. till-access user         (tillData.tillAccess.csUserId) — pre-BUG-2232
 *      behaviour, kept as a fallback so the output is byte-identical when the
 *      two match (the normal single-cashier case) and when userData has not been
 *      bootstrapped yet. userData.user_id and csUserId are the same id space
 *      (both cs_user PK — Purchase Order / Inventory already write
 *      userData.user_id straight into created_by).
 *   3. "" — only reachable when both are absent (previously this threw on
 *      `tillData.tillAccess.csUserId`), i.e. strictly safer.
 *
 * @param {object} tillData - useAuthStore tillData (tillAccess resolved to an object)
 * @returns {string} cs_user id to stamp as created_by / opened_by
 */
export const resolveActingUserId = (tillData) => {
  const liveUserId = useAuthStore.getState().userData?.user_id;
  return liveUserId || tillData?.tillAccess?.csUserId || "";
};

export default resolveActingUserId;
